import { parkingList } from '@/api/ltParking'

const state = {
  parkingTypeLane: [], // 停车场列表(道闸)
  parkingTypeSpace: [], // 停车场列表(路侧)
  parkingList: [], // 停车场列表
  msgCount:{
    msgNumber:0,
    deviceOfflineInCount : 0,
    deviceOfflineOutCount : 0,
    deviceOfflineCount : 0,
    orderAlertcount: 0,
    reviewAppealcount: 0,
    kaipiaoCount:0
  },
  hideExportId: '部门ID',
  ssHideExportId: 'c4b7ace7dce8482a9344292c1c3a6d3e'
}

const mutations = {
  MSG_COUNT(state, data) {
    state.msgCount = data
  },

  PARKING_LIST(state, data) {
    state.parkingList = data
  },

  PARKING_TYPE_SPACE(state, data) {
    state.parkingTypeSpace = data
  },

  PARKING_TYPE_LANE(state, data) {
    state.parkingTypeLane = data
  }
}

const actions = {
  setMsgCount({ commit }, obj){
    commit('MSG_COUNT', obj)
  },
  getParkingList({ commit }, obj) {
    return new Promise((resolve, reject) => {
      if (!obj) {
        obj = { 'pageSize': 1000, 'enabledmark': 1 }
      }
      parkingList(obj).then(response => {
        commit('PARKING_LIST', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParkingTypeLane({ commit }, obj) {
    return new Promise((resolve, reject) => {
      if (!obj) {
        obj = { 'pageSize': 1000, 'enabledmark': 1, 'type': 1 }
      }
      parkingList(obj).then(response => {
        commit('PARKING_TYPE_LANE', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParkingTypeSpace({ commit }, obj) {
    return new Promise((resolve, reject) => {
      if (!obj) {
        obj = { 'pageSize': 1000, 'enabledmark': 1, 'type': 0 }
      }
      parkingList(obj).then(response => {
        commit('PARKING_TYPE_SPACE', response.data)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
